import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss'],
})
export class ThankyouComponent implements OnInit {
  uni_code:any;
  constructor(public route:ActivatedRoute) { 
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.uni_code))
      this.uni_code=JSON.parse(params.uni_code);
      //this.pay_mode=JSON.parse(params.pay_mode);
      // alert(this.product_id)
      // if (params && params.special) {
      //   this.data = JSON.parse(params.special);
      // }
      
    });
  }

  ngOnInit() {}

}
